import { render, staticRenderFns } from "./role-table.vue?vue&type=template&id=6e20a8e4&"
import script from "./role-table.vue?vue&type=script&lang=js&"
export * from "./role-table.vue?vue&type=script&lang=js&"
import style0 from "./role-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports